module.exports = __webpack_public_path__ + "media/roast_animation.5a97e860.mp4";